import { render, staticRenderFns } from "./InstagramWidget.vue?vue&type=template&id=030ae226&"
import script from "./InstagramWidget.vue?vue&type=script&lang=ts&"
export * from "./InstagramWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports